import React, { useState , useRef, useEffect} from 'react';
import QuestionBox from './questionbox';
import QuestionnaireBuilder from './question_multi'
import TimelineSection from './TimelineSection';
import FileUploader from './FileUploader';

import {main_url} from  './basefile';
import MenuItem from '@mui/material/MenuItem';
import FloatingbackButton from './Floatbt_backy.jsx';
import FloatinglogoutButton from './Floatbt_logout';

import {
  Box,
  TextField,
  Typography,
  Grid,
  Paper,
  Button,
  Snackbar,
  Alert,
  Container,
  Divider,
  InputBase,
  OutlinedInput,
  Tab
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { blueGrey } from '@mui/material/colors';
import { fetchClientDropdown } from '../services/clientService';

/*
{
  "name": "string",
  "description": "string",
  "type": "internal",
  "start_date": "2019-08-24",
  "end_date": "2019-08-24",
  "project_manager": 0,
  "cost": "string",
  "status": "planned",
  "number_of_visits": 2147483647,
  "interval_days": 2147483647,
  "buffer_window_days": 2147483647
}
  */



const Projectadd = () => {

   const timelineRef = useRef();

  const [formData, setFormData] = useState({
  cid: "",
  name: "",
  description: "",
  project_manager_name:"",
  type: "internal",
  start_date: "",
  end_date: "",
  cost: "",
  status: "planned",
  project_code:"",
  number_of_visits: 1,
  interval_days: 0,
  buffer_window_days: 0
  });

  const [clients, setClients] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const items = await fetchClientDropdown();
        if (!cancelled) setClients(items || []);
      } catch {
        if (!cancelled) setClients([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const [projectId, setProjectid]=useState(0);
  const [success, setSuccess] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const [totalvisits, setTotalvisits] = useState(0);
  const [showatt, setShowatt] = useState(false);

  const handleAddBox = () => {
    setShowBox(true);
  };

  

  const handleClose = () => {
    setShowBox(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /*
   const scdata =
   {
     "planned_date":"2025-08-06",
     "project": 22,
     "interval":"3",
     "window_size":"NA",
     "schedule_type":"static"
   };


 const scdata1 =
   {
     "planned_date":"2025-08-06",
     "project": 22,
     "interval":"3",
     "window_size":"5",
     "schedule_type":"static",
     "status":"planned",
     "actual_date": "2025-08-08",
     "patient": 1,
     "project":1
   };

   const scdata2 =
   {
     "planned_date":"2025-08-06",
     "project": 22,
     "interval":"4",
     "window_size":"4",
     "schedule_type":"dynamic",
     "status":"planned",
     "actual_date": "2025-08-08",
     "patient": 1,
     "project":1
   };

    const testsctemp = async (e) => {

       const token  = localStorage.getItem('authToken'); 

        try {
                
        const res = await fetch(`${main_url}/api/v1/project-schedules/`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // or Token if your backend uses that
        },
        body: JSON.stringify(scdata),
        });

         //alert(res.status );
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.detail || 'Failed to create schedule twmpl');
          alert(res.status );
        }

      if (res.ok) {
         
          const data = await res.json(); 
          alert(JSON.stringify(data, null, 2));
          
        
      } else {
        alert('Failed to create schedule twmpl for the project ');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      //alert('Error connecting to server', error );
    }
};

const get_scheduletemp = async () => {

       const token  = localStorage.getItem('authToken'); 
       const execution_pk = 50;
       alert("get called")
       // http://13.201.185.64:8000/api/v1/executions/{execution_pk}/schedules/
       
        try {
                //http://13.201.185.64:8000/api/v1/executions/{execution_pk}/schedules/
        const res = await fetch(`${main_url}/api/v1/executions/${execution_pk}/schedules/`, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // or Token if your backend uses that
        },
       
        });

         //alert(res.status );
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.detail || 'Failed to create schedule twmpl');
          alert(res.status );
        }

      if (res.ok) {
       
         const data = await res.json(); 
       
          alert(JSON.stringify(data, null, 2));
          
        
      } else {
        alert('Failed to create schedule twmpl for the project ');
        alert("get df called")
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert("get error called" +error )
      //alert('Error connecting to server', error );
    }
};


// schedule update API 
const update_scheduletemp = async (e) => {

       const token  = localStorage.getItem('authToken'); 
       const execution_pk = 50;
       const id = 176;
        try {
                
               // http://13.201.185.64:8000/api/v1/executions/{execution_pk}/schedules/{id}/
        const res = await fetch(`${main_url}/api/v1/executions/${execution_pk}/schedules/${id}/`, {
        method: 'PATCH',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // or Token if your backend uses that
        },
        body: JSON.stringify(scdata2),
        });

         //alert(res.status );
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.detail || 'Failed to create schedule twmpl');
          alert(res.status );
        }

      if (res.ok) {
        //setSuccess(true);
         const data = await res.json(); 
       
          //alert(JSON.stringify(data, null, 2));
          //setProjectid( data.projectId);
        
      } else {
        alert('Failed to create schedule twmpl for the project ');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      //alert('Error connecting to server', error );
    }
};

*/

  const handleSubmit = async (e,visitc) => {
        //alert(visitc);
        setTotalvisits(visitc);
         //  handleAddBox(true);
          // set interval value
          
    e.preventDefault(); 

    if (!formData.cid) {
      alert('Client is required');
      return;
    }
    if (!formData.name.trim()) {
      alert('Project name is required');
      return;
    }
    if (!formData.type || !formData.status) {
      alert('Project type and status are required');
      return;
    }
    if (!formData.start_date || !formData.end_date) {
      alert('Start date and end date are required');
      return;
    }
    const nVisits = Number(formData.number_of_visits);
    if (!Number.isFinite(nVisits) || nVisits < 1) {
      alert('Number of visits must be at least 1');
      return;
    }

    const payload = {
      cid: formData.cid,
      name: formData.name.trim(),
      description: formData.description?.trim() ?? '',
      type: formData.type,
      status: formData.status,
      project_manager_name: formData.project_manager_name?.trim() || null,
      project_code: formData.project_code?.trim() || null,
      start_date: formData.start_date,
      end_date: formData.end_date,
      number_of_visits: nVisits,
      interval_days: Number(formData.interval_days) || 0,
      buffer_window_days: Number(formData.buffer_window_days) || 0,
      is_configured: false,
    };

    try {
        const token  = localStorage.getItem('authToken');            
        const res = await fetch(`${main_url}/api/v1/projects/`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // or Token if your backend uses that
        },
        body: JSON.stringify(payload),
        });

         //alert(res.status );
        if (res.status !== 201) {
          alert("Bad parameter given : Error code " + res.status );
          const errorData = await res.json();
          throw new Error(errorData.detail || 'Failed to create project');
        }

      if (res.ok) {
        setSuccess(true);
        const data = await res.json();   
        setProjectid(data.id);
        handleAddBox();
        setShowatt(true);

        setFormData({
          cid: "",
          name: "",
          description: "",
          project_manager_name: "",
          type: "internal",
          start_date: "",
          end_date: "",
          cost: "",
          status: "planned",
          project_code: "",
          number_of_visits: 1,
          interval_days: 0,
          buffer_window_days: 0,
        });
        
      } else {
        alert('Failed to save subject info');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      //alert('Error connecting to server', error );
    }


  };


  return (
    <Box sx={{   bgcolor: '#f5f5f5', minHeight: '100vh' }}>
       <Box
              sx={{ pt:0,
                height: 200,
                width:"100%",
                bgcolor: '#2a366e',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                borderRadius: 0,
      
              }}
            > <br></br> <br></br><br></br>
              <Typography variant="h4" fontWeight="bold"  >
                Project
              </Typography>
            </Box>
      <Container maxWidth="md" >
        <Paper
          elevation={3}
          sx={{ p: 5, borderRadius: 3, mx: 'auto', bgcolor: '#fff', mt:1 }}
             >
               <br></br>
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mt: 2, fontWeight: 'bold', color: '#190d3aff'   }}>
            Add New Project
          </Typography>
 <br></br>
         
          <form onSubmit={(e) => handleSubmit(e, formData.number_of_visits)}>


 {/* === Basic Details Section === */}
  <Typography variant="h6" gutterBottom sx={{ mt: 2, fontWeight: 'bold',  }}>
    Basic Details
  </Typography> 
  <Divider sx={{ mb:2 , borderBottomWidth: 2 }} />

  <Grid container spacing={3}>
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2" gutterBottom>
        Client
      </Typography>
      <TextField
        select
        name="cid"
        value={formData.cid}
        onChange={handleChange}
        fullWidth
        size="small"
        required
      >
        <MenuItem value="" disabled>
          Select client
        </MenuItem>
        {(clients || []).map((c) => (
          <MenuItem key={c.cid} value={c.cid}>
            {c.name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item xs={12} sm={6}>
<Typography variant="subtitle2" gutterBottom>
  Project Name
</Typography>
      <TextField
    
        name="name"
        value={formData.name}
        onChange={handleChange}
        fullWidth
        size="small"
        required
      />
    </Grid>

  
    <Grid item xs={12} sm={6}>
        <Typography variant="subtitle2" gutterBottom>
  Project Type
</Typography>
      <TextField
        select
        required
        name="type"
        value={formData.type}
        onChange={handleChange}
        fullWidth={false}
        size="small"
         style={{ width: '222px' }}
        >
          <MenuItem value="internal">Internal</MenuItem>
          <MenuItem value="external">External</MenuItem>
          <MenuItem value="research">Research</MenuItem>
           <MenuItem value="other">other</MenuItem>

      </TextField>

    </Grid>
    <Grid item xs={12} sm={6}>
       <Typography variant="subtitle2" gutterBottom>
  Project Status
</Typography>
      <TextField
        select
        required
        name="status"
        value={formData.status}
        onChange={handleChange}
        fullWidth={false}
        size="small"
         style={{ width: '222px' }}
      >
         <MenuItem value="planned">Planned</MenuItem>
         <MenuItem value="active">Active</MenuItem>
         <MenuItem value="completed">Completed</MenuItem>
         <MenuItem value="on_hold">On_hold</MenuItem>
         <MenuItem value="cancelled">Cancelled</MenuItem>

      </TextField>

    </Grid>

    <Grid item xs={12} sm={6}>
       <Typography variant="subtitle2" gutterBottom>
  Project Personnel
</Typography>
      <TextField
       
        name="project_manager_name"
        value={formData.project_manager_name}
        onChange={handleChange}
        fullWidth
        size="small"
      />
    </Grid>
     <Grid item xs={12} sm={6}>
       <Typography variant="subtitle2" gutterBottom>
  Project Id
</Typography>
      <TextField
      
        name="project_code"
        value={formData.project_code}
        onChange={handleChange}
        fullWidth
        size="small"
        required
      />
    </Grid>

    <Grid item xs={12} sm={6}>
       <Typography variant="subtitle2" gutterBottom>
  Description
</Typography>
      <TextField
        
        name="description"
        value={formData.description}
        onChange={handleChange}
        fullWidth
        size="small"
      />
    </Grid>
  </Grid>

  {/* === Timeline Section === */}
  <Typography variant="h6" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
    Timeline
  </Typography>
  <Divider sx={{ mb: 2 , borderBottomWidth: 2 }} />

  <Grid container spacing={3}>
    <Grid item xs={12} sm={6}>
        <Typography variant="subtitle2" gutterBottom>
Start Date
</Typography>
      <DatePicker
        label="Start Date"
        format="MM/DD/YYYY"
        value={formData.start_date ? dayjs(formData.start_date) : null}
        onChange={(value) =>
          setFormData((prev) => ({
            ...prev,
            start_date: value && value.isValid() ? value.format('YYYY-MM-DD') : '',
          }))
        }
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            style: { width: '222px' },
            required: true,
          },
        }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
       <Typography variant="subtitle2" gutterBottom>
End Date
</Typography>
      <DatePicker
        label="End Date"
        format="MM/DD/YYYY"
        value={formData.end_date ? dayjs(formData.end_date) : null}
        onChange={(value) =>
          setFormData((prev) => ({
            ...prev,
            end_date: value && value.isValid() ? value.format('YYYY-MM-DD') : '',
          }))
        }
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            style: { width: '222px' },
            required: true,
          },
        }}
      />
    </Grid>  


    <Grid item xs={12} sm={4}>
        <Typography variant="subtitle2" gutterBottom>
 Number of Visits
</Typography>
      <TextField
        required
        name="number_of_visits"
        type="number"
        inputProps={{ min: 1 }}
        value={formData.number_of_visits}
        onChange={handleChange}
        fullWidth
        size="small"
      />
    </Grid>

  </Grid>

  {/* === Miscellaneous Section === */}
  <Typography variant="h6" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
    Miscellaneous
  </Typography>
  <Divider sx={{ mb: 2 , borderBottomWidth: 2 }} />

  <Grid container spacing={3}>
    
   
    <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      
      <TextField
        
        name= "comments"
        value={formData.comments || ''}
        onChange={handleChange}
         style={{ width: '465px' }}
         size="large"
      />
    </Grid>
  </Grid>
            
      {/* Add schedule creation template here  */}


            {/* Submit Button */}
            <Box mt={4} textAlign="right">
              <Button type="submit" variant="contained" color="primary">
                Save
              </Button>
            </Box>
          </form>
        </Paper>

          {
          
          showBox ? <TimelineSection  projectId={projectId}  totalvisits={totalvisits} onClose={handleClose} /> : <Typography></Typography>
          
          }

          <br></br><br></br>
            {
              showatt ? <FileUploader obj_id={projectId} catog={1}/> : <Typography></Typography>
             }
  
         </Container>

          
      {/* Success Snackbar */}
      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
         <Box
          position="fixed"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          zIndex={1300} // on top of most elements
          >
          <Alert severity="success" variant="filled">
            New Project added!
          </Alert>
          </Box>
      </Snackbar>

  {/* <QuestionnaireBuilder projectId={projectId} /> */}
 <FloatingbackButton />
 
</Box>
  );
};

export default Projectadd;
